window.addEventListener('load', () => {
    const container = document.querySelector('main.single-aanbod-page');
    if (!container) return;

    const tabs_container = container.querySelector<HTMLElement>('.tabs');

    const tabs = container.querySelectorAll<HTMLElement>('.tabs input');
    const links = container.querySelectorAll<HTMLElement>('[data-tab-link]');
    const tab_contents = container.querySelectorAll<HTMLElement>('[data-tab-content]');

    const select_tab = (value: string) => {
        tabs.forEach(tab => {
            const input = tab as HTMLInputElement;
            input.checked = input.value === value;
        });
        render_tab_contents();
    }

    const get_active_tab = (): string | null => {
        let active_tab: string | null = null;
        tabs.forEach(tab => {
            const input = tab as HTMLInputElement;
            if (input.checked) {
                active_tab = input.value;
            }
        });
        return active_tab;
    }

    const render_tab_contents = () => {
        const active_tab = get_active_tab();
        tab_contents.forEach(content => {
            const content_tab = content.getAttribute('data-tab-content');
            if (content_tab === active_tab) {
                content.classList.remove('hide-tab')
            } else {
                content.classList.add('hide-tab')
            }
        });
        // set hash
        if (active_tab) {
            history.replaceState(null, '', `#${active_tab}`);
        }

    }


    links.forEach(item => {
        item.addEventListener('click', (e) => {
            e.preventDefault();
            const tab = item.getAttribute('data-tab-link');
            if (!tab) return;
            select_tab(tab);
        });
    })

    tabs.forEach(tab => {
        tab.addEventListener('change', () => {
            render_tab_contents();
        });
    });

    // hash support
    function handle_hash() {

        const hash = window.location.hash.substring(1);
        if (hash) {
            const tab_exists = Array.from(tabs).some(tab => {
                const input = tab as HTMLInputElement;
                return input.value === hash;
            });
            if (tab_exists) {
                select_tab(hash);
            } else {
                render_tab_contents();
            }
        }

        //scroll to tabs
        if (tabs_container && hash) {
            const tabs_top = tabs_container.getBoundingClientRect().top + window.scrollY - (window.header_height ?? 128);
            window.scrollTo({
                top: tabs_top,
                behavior: 'smooth'
            });
        }

    }

    window.addEventListener('hashchange', handle_hash);
    handle_hash();
});
